import { render, staticRenderFns } from "./styling.vue?vue&type=template&id=688826c6"
import script from "./styling.vue?vue&type=script&lang=js"
export * from "./styling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports